import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterView from '@/components/router-view.vue';
import PersonCenterCom from '@/views/person-center/person-center.vue';
// import AboutUsCom from '@/views/about-us/about-us.vue';
import SignCom from '@/components/sign.vue';

// route
import AboutUsRouting from '../views/about-us/about-us-routing.js';
import RegisterRouting from '../views/register/register-routing.js';
import PublishProjectRouting from '../views/publish-project/publish-project-routing.js';
import PublishPurchaseRouting from '../views/publish-purchase/publish-purchase-routing.js';
import PersonCenterRouting from '../views/person-center/person-center-routing.js';
import NewsRouting from '../views/news/news-routing';
import TradingRulesRouting from '../views/trading-rules/trading-rules-routing';
import DataDownloadRouting from '../views/data-download/data-download-routing';
import CollectivePurchasingRouting from '../views/collective-purchasing/collective-purchasing-routing';
import TransactionProRouting from '../views/transaction-pro/transaction-pro-routing'; // 交易项目
import NoticeModularRouting from '../views/notice-modular/notice-modular-routing'; // 统一公告
import BidProjectRouting from '../views/bid-project/bid-project-routing'; // 统一公告
import RegistrationHostingRouting from '../views/registration-hosting/registration-hosting-routing'; // 交易项目
import ForgetPasswordRouting from '../views/forget-password/forget-password-routing.js'; // 忘记密码

import socializedServiceRouting from '../views/socialized-service/socialized-service-routing.js'; // 社会化服务
import financeInsuranceRouting from '../views/finance-insurance/routing.js'; // 普惠金融
import SupplyAndDemandRouting from '../views/supply-and-demand/routing.js'; // 供求信息

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'root',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'home', // 首页
    component: () => import('@/views/home/index.vue')
  },
  {
    path: '/gis',
    name: 'gis',
    component: () => import('@/views/home/map-hotspot/gis-map/index.vue')
  },
  {
    path: '/tools/pug-html-pdf',
    name: 'pugHtmlPdf',
    component: () => import('@/views/tools/pug-html-pdf/index.vue')
  },
  {
    path: '/register',
    name: 'register', // 注册
    component: RouterView,
    children: RegisterRouting
  },
  {
    path: '/signin',
    name: 'signin', // 登录
    component: () => import('@/views/signin/signin.vue')
  },
  {
    path: '/publish-project',
    name: 'publishProject', // 发布项目
    component: RouterView,
    children: PublishProjectRouting
  },
  {
    path: '/publish-purchase',
    name: 'publishPurchase', // 发布采购项目
    component: RouterView,
    children: PublishPurchaseRouting
  },
  {
    path: '/person-center',
    name: 'personCenter', // 个人中心
    component: PersonCenterCom,
    children: PersonCenterRouting,
    meta: {
      title: '个人中心',
      breadCrumbShowIndexArr: [0, 1]
    }
  },
  {
    path: '/news',
    name: 'news', // 新闻中心
    component: RouterView,
    children: NewsRouting,
    redirect: '/news/news-list/1',
    meta: {
      title: '新闻中心',
      breadCrumbShowIndexArr: [0, 1]
    }
  },
  {
    path: '/trading-rules',
    name: 'tradingRules', // 政策规章
    component: RouterView,
    children: TradingRulesRouting,
    redirect: '/trading-rules/trading-rules-list/1',
    meta: {
      title: '政策规章',
      breadCrumbShowIndexArr: [0, 1]
    }
  },
  {
    path: '/socialized-service',
    name: 'socializedService',
    redirect: '/socialized-service/partner/register',
    component: RouterView,
    children: socializedServiceRouting,
    meta: {
      title: '社会化服务',
      breadCrumbShowIndexArr: [0, 1]
    }
  },
  {
    path: '/finance-insurance',
    name: 'financeInsurance', // 普惠金融
    component: RouterView,
    children: financeInsuranceRouting,
    redirect: '/finance-insurance/list',
    meta: {
      title: '金融服务',
      breadCrumbShowIndexArr: [0, 1]
    }
  },
  {
    path: '/data-download',
    name: 'dataDownload', // 资料下载
    component: RouterView,
    children: DataDownloadRouting
  },
  {
    path: '/forget-password',
    name: 'forgetPassword', // 忘记密码
    component: RouterView,
    children: ForgetPasswordRouting,
    meta: {
      title: '忘记密码',
      breadCrumbShowIndexArr: [0, 1]
    }
  },
  {
    path: '/about-us',
    name: 'aboutUs', // 关于我们
    component: RouterView,
    children: AboutUsRouting,
    meta: {
      title: '关于我们',
      breadCrumbShowIndexArr: [0, 1]
    }
  },
  {
    path: '/collective-purchasing',
    name: 'collectivePurchasing', // 集体采购
    component: RouterView,
    children: CollectivePurchasingRouting,
    redirect: '/collective-purchasing/list',
    meta: {
      title: '采购公告'
    }
  },
  {
    path: '/transaction-pro',
    name: 'transactionPro', // 交易项目
    component: RouterView,
    children: TransactionProRouting,
    redirect: '/transaction-pro/list',
    meta: {
      title: '交易项目'
    }
  },
  {
    path: '/notice-modular',
    name: 'noticeModular', // 通知公告
    component: RouterView,
    children: NoticeModularRouting,
    redirect: '/notice-modular/list',
    meta: {
      title: '通知公示'
    }
  },
  {
    path: '/registration-hosting',
    name: 'registrationHosting', // 通知公告
    component: RouterView,
    children: RegistrationHostingRouting,
    redirect: '/registration-hosting/hostList',
    meta: {
      title: '登记托管'
    }
  },
  {
    path: '/bid-project',
    name: 'bidProject', // 通知公告
    component: RouterView,
    children: BidProjectRouting,
    redirect: '/bid-project/list',
    meta: {
      title: '竞价大厅'
    }
  },
  {
    path: '/supply-and-demand',
    name: 'supply-and-demand', // 通知公告
    component: RouterView,
    children: SupplyAndDemandRouting,
    redirect: '/supply-and-demand/list',
    meta: {
      title: '供需大厅'
    }
  },
  {
    path: '/sign/:id',
    name: 'h5Sign', // 签约页面
    component: SignCom
  }
];

const router = new VueRouter({
  routes
});

export default router;
